import { useAuth0 } from '@auth0/auth0-react';
import { Suspense } from 'react';
import Loading from '../ui/loading/Loading';

function AuthWrapper({ children }) {
    const {
        isLoading,
        error,
    } = useAuth0();
    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <div>Oops... {error.message}</div>;
    }

    return (
        <Suspense fallback={<Loading />}>
            <>{children}</>
        </Suspense>
    )
}
export default AuthWrapper;